"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const type_1 = require("../../../type");
const FieldEmitter_1 = require("../child/FieldEmitter");
const Field_Container_1 = require("../components/Field.Container");
const useEventEmitter_1 = require("../emitter/useEventEmitter");
const Field_Body_1 = require("../utils/Field.Body");
const Field_Function_1 = require("../utils/Field.Function");
const Field_LoadData_1 = require("../utils/Field.LoadData");
const Field_Validation_1 = require("../utils/Field.Validation");
const CoreContainer = ({ mode = "normal", label = "", name = "", FieldReference = "", index = 0, disabled = false, loadData = {}, language = "TH", style = {}, required = false, type = "text", unit = "", placeholder = "", emitter = "", render = false, renderError = false, number = false, email = false, classNameInput = "", classNameLabel = "", classNameWrapper = "", classNameUnit = "", isEdit = true, classNameValue = "", subLabel = "", classNameSubLabel = "", recipient = false, options = [], isMultiple = false, classNameOptions = "", classNameOption = "", classNameValues = "", fieldCustoms = false, getPathUrl = "", accept = "image/jpeg,image/png", classNameError = "", fieldIndex = -1, grandParentIndex = -1, grandParentKey = "", parentIndex = -1, parentKey = "", direction = "vertical", limit = false, classNameIcon = "", showError = true, renderFooter = false, minimum = 0, select = [], defualtValue = "", count = 6, // default value of otp length
labelUpload = false, trigger = false, dataType = "default", reset = false, FunctionReset = () => { }, initalValue, showSymbol, errorCustoms = false, isLastStep, isFirstStep, arrayCount, isStep, FunctionAddStep, FunctionRemoveStep, noSpace = false, noSpecialCharacter, min = "", max = "", autoScale = false, resetValueWhenEmitterChange = false, onKeyPress = false, fields = [], currentData, FunctionEditStep, childType = type_1.TYPE_ARRAY, errorName = "", }) => {
    const [value, setValue] = React.useState("");
    const [listener, setListener] = React.useState("");
    const { emit, useListener } = (0, useEventEmitter_1.useEventEmitter)();
    const reference = React.useRef("");
    const FunctionGetThisValue = (0, Field_Validation_1.FunctionCheckValidation)(mode, language, (0, Field_Function_1.FunctionGetModelError)(required, number, email, limit, minimum, noSpace, noSpecialCharacter), name, dataType === "default"
        ? (value === null || value === void 0 ? void 0 : value.label) === "" || (value === null || value === void 0 ? void 0 : value.label)
            ? value === null || value === void 0 ? void 0 : value.value
            : value || ""
        : value, type, errorCustoms, listener, label, errorName);
    React.useEffect(() => {
        let isMounted = true;
        if (reset) {
            setValue("");
        }
        return () => {
            isMounted = false;
        };
    }, [reset]);
    React.useEffect(() => {
        if (initalValue && value === "") {
            (0, Field_LoadData_1.FunctionInitalData)({
                loadData,
                name,
                parentIndex,
                parentKey,
                fieldIndex,
                grandParentIndex,
                grandParentKey,
                type,
                value,
                setValue,
                options,
                initalValue,
                childType,
            });
        }
    }, [initalValue]);
    React.useEffect(() => {
        (0, Field_LoadData_1.FunctionLoadData)({
            loadData,
            name,
            parentIndex,
            parentKey,
            fieldIndex,
            grandParentIndex,
            grandParentKey,
            type,
            value,
            setValue,
            options,
            initalValue,
            childType,
        });
    }, [loadData]);
    (0, FieldEmitter_1.FieldEmitter)(emit, emitter, name, value);
    useListener(`${Array.isArray(emitter) ? undefined : emitter}-${name}`, (recived) => {
        if (recipient) {
            setListener(recived);
            if (resetValueWhenEmitterChange) {
                setValue("");
            }
        }
    });
    // const hasOther = options.findIndex((i) => i === "Other") > -1;
    // Will add in the future field custom other
    return (React.createElement(Field_Container_1.FieldContainer, { FunctionGetThisValue: FunctionGetThisValue, inputBody: React.createElement(Field_Body_1.FunctionBody, { FunctionReset: FunctionReset, reset: reset, mode: mode, label: label, name: name, FieldReference: FieldReference, index: index, disabled: disabled, language: language, style: style, type: type, unit: unit, placeholder: placeholder, isEdit: isEdit, setValue: setValue, reference: reference, options: options, isMultiple: isMultiple, value: value, classNameInput: classNameInput, classNameLabel: classNameLabel, classNameWrapper: classNameWrapper, classNameUnit: classNameUnit, classNameValue: classNameValue, classNameSubLabel: classNameSubLabel, classNameValues: classNameValues, classNameOptions: classNameOptions, classNameOption: classNameOption, classNameIcon: classNameIcon, fieldCustoms: fieldCustoms, getPathUrl: getPathUrl, accept: accept, direction: direction, received: listener, showError: showError, select: select, defualtValue: defualtValue, count: count, trigger: trigger, labelUpload: labelUpload, fieldIndex: fieldIndex, grandParentIndex: grandParentIndex, grandParentKey: grandParentKey, parentIndex: parentIndex, parentKey: parentKey, isLastStep: isLastStep, isFirstStep: isFirstStep, arrayCount: arrayCount, isStep: isStep, FunctionAddStep: FunctionAddStep, FunctionRemoveStep: FunctionRemoveStep, FunctionEditStep: FunctionEditStep, thisValue: FunctionGetThisValue, min: min, max: max, autoScale: autoScale, onKeyPress: onKeyPress, fields: fields, currentData: currentData }), setValue: setValue, classNameLabel: classNameLabel, classNameWrapper: classNameWrapper, classNameValue: classNameValue, label: label, required: required, index: index, name: name, value: type === type_1.TYPE_NONE ? listener : value, FieldReference: FieldReference, isEdit: isEdit, reference: reference, renderError: renderError, subLabel: subLabel, classNameSubLabel: classNameSubLabel, render: render, classNameError: classNameError, fieldIndex: fieldIndex, grandParentIndex: grandParentIndex, grandParentKey: grandParentKey, parentIndex: parentIndex, parentKey: parentKey, showError: showError, renderFooter: renderFooter, showSymbol: showSymbol, received: listener, currentData: currentData, childType: childType }));
};
exports.default = CoreContainer;
